import React from 'react';
import './constants/styles/landing.scss';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import MasksIcon from '@mui/icons-material/Masks';
import Header from './patient/containers/Header';

const Landing = ({ navigateTo }) => {
    return (
        <>
            <Header hideWithdrawButton={true} />
            <div className='landing-container'>
                <div className='landing-text'>Log in as a...</div>
                <div className='button-container'>
                    <button className='landing-button' onClick={() => navigateTo('patient')}>
                        <EscalatorWarningIcon />
                        Patient
                    </button>
                    <button className='landing-button' onClick={() => navigateTo('clinician')}>
                        <MasksIcon />
                        Clinician
                    </button>
                </div>
            </div>
        </>
    );
};

export default Landing;